<template>
    <div class="map-card">
        <div class="map-card-header">
            <div class="map-card-icon">
                <i class="fal fa-map"></i>
            </div>
            <div>
                <h3 class="map-card-title">Carte</h3>
                <p class="map-card-subtitle">{{ filteredPosts.length }} ticket(s) localisé(s)</p>
            </div>
        </div>
        <div class="map-card-body">
        <l-map
            :center="center"
            ref="myMap"
            :zoom="zoom"
            :bounds="bounds.length > 0 ? bounds : undefined"
            class="map-card-map"
            @update:zoom="updateZoom($event)"
        >
            <l-tile-layer :attribution="attribution" :url="url" />
            <v-marker-cluster v-if="filteredPosts.length > 0">
                <l-marker
                    v-for="post in filteredPosts"
                    :key="post.id"
                    :lat-lng="getCoord(post)"
                    :options="optionsZoom"
                >
                    <l-popup>
                        <PanelKanban
                            :post="post"
                            class="w-72 h-30"
                            :withStatus="true"
                        >
                        </PanelKanban>
                    </l-popup>
                </l-marker>
            </v-marker-cluster>
        </l-map>
        </div>
    </div>
</template>

<script>
import PanelKanban from '../../../components/UI/PanelKanban'

require('leaflet.snogylop')
import { L, latLng, LatLngBounds } from 'leaflet'
import {
    LMap,
    LTileLayer,
    LGeoJson,
    LPolygon,
    LMarker,
    LPopup,
    LIcon,
    LControl,
    LTooltip
} from 'vue2-leaflet'

export default {
    name: 'MapDashboard',
    props: ['posts'],
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        PanelKanban
    },
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; OpenStreetMap contributors',
            imagePath: '',
            icon: '',
            showPOIBox: false,
            optionsZoom: {
                maxZoom: 22,
                maxNativeZoom: 20
            },
            markers: [],
            filteredPosts: []
        }
    },
    computed: {
        zoom: {
            get() {
                return this.$store.state.map.config.zoom
            },
            set(value) {
                this.$store.commit('map/setZoom', value)
            }
        },
        center() {
            if (!this.filteredPosts || this.filteredPosts.length === 0) {
                return [46.603354, 1.888334] // France center
            }
            let lat = 0
            let lon = 0
            this.filteredPosts.forEach((post) => {
                lat += post.location.lat
                lon += post.location.lon
            })
            return [lat / this.filteredPosts.length, lon / this.filteredPosts.length]
        },
        bounds() {
            if (
                this.filteredPosts &&
                typeof this.filteredPosts != 'undefined'
            ) {
                this.filteredPosts.forEach((post) => {
                    this.markers.push({
                        lat: post.location.lat,
                        lon: post.location.lon
                    })
                })
                return this.markers.map((m) => {
                    if (m.lat && m.lon) return [m.lat, m.lon]
                })
            }
            return [[0, 0]]
        }
    },
    methods: {
        updateZoom: function (zoom) {
            this.zoom = zoom
        },
        getCoord(post) {
            return latLng(post.location.lat, post.location.lon)
        }
    },
    created() {
        this.filteredPosts = this.posts.filter((post) => {
            return post.location.lon && post.location.lat
        })
    }
}
</script>

<style scoped>
.map-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
}

.map-card-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 20px;
    border-bottom: 1px solid #e2e8f0;
}

.map-card-icon {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #ecfeff;
    color: #0891b2;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.map-card-title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #0f172a;
    margin: 0;
}

.map-card-subtitle {
    font-size: 0.8rem;
    color: #94a3b8;
    margin: 3px 0 0;
}

.map-card-body {
    padding: 16px;
}

.map-card-map {
    height: calc(100vh - 320px);
    min-height: 500px;
    width: 100%;
    z-index: 1;
    border-radius: 8px;
}
</style>
